import signatureUrl from '../assets/registrar-signature.svg';

interface Props {
  className?: string;
}

/** The registrar's handwritten signature graphic, shown on official transcripts. */
const RegistrarSignature = ({ className }: Props) => (
  <img src={signatureUrl} alt="Registrar signature" className={className} />
);

export default RegistrarSignature;
